import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import { getUsersData } from "../../store/actions"
import UsersTable from "./UsersTable"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

const Dashboard = props => {
  const dispatch = useDispatch()

  const themeColor = useSelector(state => state.theme.color)
  useEffect(() => {
    document.documentElement.style.setProperty("--scrollbar-color", themeColor)
  }, [themeColor])

  // useEffect(() => {
  //   dispatch(getUsersData())
  // }, [dispatch])

  //meta title
  document.title = "Users - ColdBlock Technologies Inc."

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Users")}
          /> */}
          <Row>
            <Col lg="12">
              <UsersTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  getUsersData: PropTypes.func,
}

export default withTranslation()(Dashboard)
